module.exports = __webpack_public_path__ + "static/media/chat11.7fdedacb.gif";